(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (document.body.classList.contains('collection')) {
    const collectionFilterScrollSelector = '.main-collection [data-collection-filter-scroll]';
    let collectionFilterScrollFrame;

    function updateCollectionFilterHeight() {
      collectionFilterScrollFrame = undefined;
      if (!window.matchMedia('(min-width: 1024px)').matches) return;

      document.querySelectorAll(collectionFilterScrollSelector).forEach((panel) => {
        if (!panel.getClientRects().length) return;
        const top = Math.max(0, panel.getBoundingClientRect().top);
        const height = Math.floor(window.innerHeight - top - 24);
        if (height <= 0) return;
        const value = `${height}px`;
        if (panel.style.getPropertyValue('--collection-filter-height') !== value) {
          panel.style.setProperty('--collection-filter-height', value);
        }
      });
    }

    function scheduleCollectionFilterHeight() {
      if (collectionFilterScrollFrame !== undefined) return;
      collectionFilterScrollFrame = requestAnimationFrame(updateCollectionFilterHeight);
    }

    window.addEventListener('scroll', scheduleCollectionFilterHeight, { passive: true });
    window.addEventListener('resize', scheduleCollectionFilterHeight, { passive: true });
    document.addEventListener('pointerover', (event) => {
      if (event.target instanceof Element && event.target.closest(collectionFilterScrollSelector)) {
        scheduleCollectionFilterHeight();
      }
    });
    document.addEventListener('shopify:section:load', scheduleCollectionFilterHeight);
    const collectionFilterResizeObserver = new ResizeObserver(scheduleCollectionFilterHeight);
    document.querySelectorAll('.main-collection').forEach((collection) => {
      collectionFilterResizeObserver.observe(collection);
    });
    scheduleCollectionFilterHeight();
  }

  } catch(e) { console.error(e); }
})();
})();
